export const Images = {
  web3: {
    metamask: require("./web3/metamask.png")?.default,
    wallet: require("./web3/wallet.png")?.default,
  },
  login: {
    bg: require("./images/bg-img.png")?.default,
  },
};

export { default as projectfeatureimg1 } from "./images/projectfeature1.png";
export { default as mobileprojectfeatureimg1 } from "./images/mprojectfeature1.png";
export { default as mobileprojectfeatureimg2 } from "./images/mprojectfeature2.png";
export { default as mobileprojectfeatureimg3 } from "./images/mprojectfeature3.png";
export { default as mobileprojectfeatureimg4 } from "./images/mprojectfeature4.png";
export { default as mobileprojectfeatureimg5 } from "./images/mprojectfeature5.png";

export { default as projectfeatureimg2 } from "./images/projectfeature2.png";
export { default as projectfeatureimg3 } from "./images/projectfeature3.png";
export { default as projectfeatureimg4 } from "./images/projectfeature4.png";
export { default as projectfeatureimg5 } from "./images/projectfeature5.png";
export { default as tokensaleimg } from "./images/tokensale.png";
export { default as tokennomicsimg } from "./images/tokennomics.png";
export { default as tokennomicsimg1 } from "./images/tokennomics1.png";

export { default as t1 } from "./images/t1.png";
export { default as t2 } from "./images/t2.png";
export { default as t3 } from "./images/t3.png";
export { default as t4 } from "./images/t4.png";
export { default as t5 } from "./images/t5.png";

export { default as whitelist } from "./images/whitelist.png";
export { default as polygon } from "./images/polygon.png";
export { default as github } from "./images/github.png";
export { default as gitbook } from "./images/gitbook.png";

export { default as faq } from "./images/faq.png";
export { default as footerImg } from "./images/footerimg2.png";
export { default as footerlogo } from "./images/footerlogo.png";
export { default as roadmap } from "./images/roadmap.png";
export { default as roadmap1 } from "./images/roadmap1.png";
export { default as document } from "./images/document.png";

export { default as mobileroadmap } from "./images/responsiveroadmap.png";
export { default as mobileroadmap2 } from "./images/responsiveroadmap2.png";
export { default as newroadmap } from "./images/newroadmap.png";
export { default as newresponsiveroadmap } from "./images/responsiveroadmap3.png";
export { default as techimg1 } from "./images/techimg1.png";
export { default as techimg2 } from "./images/techimg2.png";
export { default as techimg3 } from "./images/techimg3.png";
export { default as techimg4 } from "./images/techimg4.png";
export { default as techimg5 } from "./images/techimg5.png";

export { default as mediaimg1 } from "./images/mediaimg1.png";
export { default as mediaimg2 } from "./images/mediaimg2.png";
export { default as mediaimg3 } from "./images/mediaimg3.png";
export { default as mediaimg4 } from "./images/mediaimg4.png";
export { default as cards } from "./images/cards.png";
export { default as mastercard } from "./images/mastercard.png";
export { default as lowFee } from "./images/lowFee.png";
export { default as bluelogo } from "./images/bluelogo.png";
export { default as fau } from "./images/fau.png";
export { default as cnb } from "./images/cnb.png";
export { default as appstore } from "./images/appstore.png";
export { default as playstore } from "./images/playstore.png";
